import React from 'react';
import { motion } from 'framer-motion';
import { SparklesIcon, LeafIcon } from 'lucide-react';
export function MechanismSection() {
  return <section className="w-full bg-white py-16 md:py-24" data-id="element-232">
      <div className="max-w-4xl mx-auto px-4" data-id="element-233">
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.7
      }} data-id="element-234">
          <div className="text-center mb-10" data-id="element-235">
            <span className="inline-flex items-center gap-2 text-[#C4A962] text-sm font-medium uppercase tracking-wider mb-4" data-id="element-236">
              <SparklesIcon className="w-4 h-4" data-id="element-237" />
              La Solución
              <SparklesIcon className="w-4 h-4" data-id="element-238" />
            </span>
            <h2 className="font-['Playfair_Display'] text-2xl md:text-3xl lg:text-4xl font-bold text-[#2D3436]" data-id="element-239">
              El Protocolo de Reinicio Vago-Reset
            </h2>
          </div>

          {/* Main mechanism card */}
          <div className="relative bg-gradient-to-br from-[#5B8F7B] to-[#4A7A66] rounded-3xl p-8 md:p-12 text-white overflow-hidden" data-id="element-240">
            {/* Decorative elements */}
            <LeafIcon className="absolute top-4 right-4 w-20 h-20 text-white/10 rotate-45" data-id="element-241" />
            <LeafIcon className="absolute bottom-4 left-4 w-16 h-16 text-white/10 -rotate-12" data-id="element-242" />

            <div className="relative z-10" data-id="element-243">
              <p className="text-lg md:text-xl leading-relaxed mb-6" data-id="element-244">
                Un método de{' '}
                <span className="font-semibold text-[#C4A962]" data-id="element-245">3 pasos</span>{' '}
                diseñado para "apagar" la señal de peligro de tu sistema
                nervioso y permitir que tu cuerpo drene el exceso de líquido
                acumulado.
              </p>

              <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 border border-white/20" data-id="element-246">
                <p className="text-lg leading-relaxed" data-id="element-247">
                  <span className="font-semibold" data-id="element-248">
                    No estamos quemando grasa
                  </span>
                  ; estamos desactivando la inflamación desde la raíz hormonal,
                  devolviéndole a tu metabolismo la seguridad que necesita para
                  soltar la retención abdominal.
                </p>
              </div>

              <div className="mt-8 flex flex-wrap gap-4 justify-center" data-id="element-249">
                <div className="bg-white/10 backdrop-blur-sm px-4 py-2 rounded-full text-sm" data-id="element-250">
                  ✓ Basado en neurobiología
                </div>
                <div className="bg-white/10 backdrop-blur-sm px-4 py-2 rounded-full text-sm" data-id="element-251">
                  ✓ Sin restricciones extremas
                </div>
                <div className="bg-white/10 backdrop-blur-sm px-4 py-2 rounded-full text-sm" data-id="element-252">
                  ✓ Resultados en 7 días
                </div>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}